import { render, staticRenderFns } from "./NumberOfPersonsPerSegment.vue?vue&type=template&id=2b26d9be&scoped=true&lang=pug&"
import script from "./NumberOfPersonsPerSegment.vue?vue&type=script&lang=js&"
export * from "./NumberOfPersonsPerSegment.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfPersonsPerSegment.vue?vue&type=style&index=0&id=2b26d9be&scoped=true&lang=stylus&"
import style1 from "./NumberOfPersonsPerSegment.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26d9be",
  null
  
)

export default component.exports